export const triggerEvent = (eventName: string, detail?: unknown) => {
  const event = new CustomEvent(eventName, {
    detail,
  });

  document.dispatchEvent(event);
};
